{
	"hooks": {
		"exportSalesByEmployee": {
			"employee": "Funcionário",
			"filename": "vendas-avulsas-por-funcionario",
			"filenameEvent": "no-evento-{{eventName}}",
			"filenamePeriod": "-de-{{since}}-ate-{{until}}",
			"title": "Vendas Avulsas por Funcionário ",
			"titleEvent": "no evento {{eventName}} ",
			"titlePeriod": "de {{since}} até {{until}}"
		},
		"exportAllSalesFromEmployee": {
			"date": "Data",
			"isRefunded": "Foi estornada",
			"refundedBy": "Estornada por",
			"refundedAt": "Estornada em",
			"value": "Valor",
			"method": "Método",
			"filename": "vendas-avulsas-de-{{employeeName}}",
			"filenameEvent": "-no-evento-{{eventName}}",
			"filenamePeriod": "-de-{{since}}-ate-{{until}}",
			"title": "Vendas Avulsas de {{employeeName}} ",
			"titleEvent": "no evento {{eventName}} ",
			"titlePeriod": "de {{since}} até {{until}}"
		}
	},
	"parseOpenSaleMethod": {
		"credit": "Crédito",
		"debit": "Débito",
		"pix": "Pix",
		"creditInInstallments": "Parcelamento",
		"integratedFoodVoucher": "Vale-refeição"
	}
}
